import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { variantAdd } from '../../helpers/api';
import { variantsAddSuccess, variantsAddError } from './actions';

import { SagaIterator } from '@redux-saga/core';
import { AxiosResponse } from 'axios';
import { VariantsActionTypes } from './constants';

function* variantAddSaga(action: any): SagaIterator {
    try {
        const response = yield call(variantAdd, action.payload);
        yield put(variantsAddSuccess(response?.data?.message));
    } catch (error: any) {
        yield put(variantsAddError(error?.message));
    }
}

function* watchVariantAdd() {
    yield takeEvery(VariantsActionTypes.VARIANTS_ADD, variantAddSaga);
}

function* variantSaga() {
    yield all([fork(watchVariantAdd)]);
}

export default variantSaga;
